export const data = {
   experience: [
      {
        title: "Specialist",
        subTitle: "on Codeforces",
        description:
          "Highest rating: 1538",
      },
      {
        title: "Participated in",
        subTitle: "Google Codejam i/o",
        description:
          "Secured Rank: 929",
      },
      {
        title: "Participated in",
        subTitle: "Google Kickstart",
        description:
          "Secured Rank: 4000",
      },
      {
        title: "Secured Third Rank",
        subTitle: "in Algo-Queen",
        description:
          "Coding competition by ICPC, 2021-Semi Finals",
      },
      {
        title: "Gold Badge in problem solving",
        subTitle: "at HackerRank",
        description:
          "also 2829th rank in global track in GeeksForGeeks.",
      },
      
      {
        title: "Head Girl",
        subTitle: "in High School",
        description:
          "also received many meritorious and cultural prizes.",
      },
    ],
    education: [
      {
        title: "Secondary",
        subTitle: "Kashyap VidyaPeeth School",
        description:
          " 10 CGPA in 10th Grade",
        date:"2015"  
      },
      {
        title: "Higher Secondary",
        subTitle: "Kashyap VidyaPeeth, Badnawar",
        description:
          " 95.6 % in 12th Grade in Science",
        date: "2017"
      },
      {
        title: "B.Tech at",
        subTitle: "Indian Institute of Technology, Ropar",
        description:
          "Mechanical Engineering with Minor in Computer Science",
        date: "2022 - 2024"
      },
      {
        title: "Courses",
        subTitle: "in IIT Ropar",
        description:
          "Introduction to Computing and Data Structures, Matlab, TinkerCad, Calculus and Marco and Micro Economics",
        date: "2020 - present"
      },
      {
        title: "Courses",
        subTitle: "from internet",
        description:
          "Certified in Self Paced Course DSA from Geeks From Geeks, Web Development Course (Udemy)",
        date: "2020 - present"
      },
      {
        title: "Certified",
        subTitle: "by HackerRank",
        description:
          "in SQL, Angular(Basics), Python and Problem Solving.",
      },
    ],
  };